import React, { KeyboardEvent, useEffect, useState } from 'react';
import { NewTableStyledTrRow } from './HBNewTable.styles';
import HBNewTableCellList from './HBNewTableCellList';
import HBNewTableSpacer from './HBNewTableSpacer';
import HBNewTableExpandedRow from './HBNewTableExpandedRow';

const HBNewTableRow = ({
    item,
    columnDefinitions,
    itemId,
    isSelectableMode,
    expandableProps,
    hasSpacer,
    isSelectable,
    isRowHovered,
    setHoveredRowItemId
}) => {
    const [isRowExpanded, setIsRowExpanded] = useState(undefined);

    useEffect(() => {
        if (isRowExpanded !== undefined) {
            expandableProps?.onExpand?.(isRowExpanded, item);
        }
    }, [expandableProps, isRowExpanded, item]);

    const expandOnClickProps = expandableProps?.expandOnRowClick
        ? {
              tabIndex: 0,
              onClick: () => {
                  if (!isSelectableMode) {
                      setIsRowExpanded(prev => !prev);
                  }
              },
              onKeyPress: (e: KeyboardEvent<HTMLDivElement>) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                      if (!isSelectableMode) {
                          setIsRowExpanded(prev => !prev);
                      }
                  }
              }
          }
        : {};

    return (
        <>
            {hasSpacer && (
                <HBNewTableSpacer
                    colSpan={columnDefinitions.length}
                    height={12}
                />
            )}
            {!hasSpacer && expandableProps && (
                <HBNewTableSpacer
                    colSpan={columnDefinitions.length}
                    height={4}
                />
            )}
            <NewTableStyledTrRow
                className="actual-row"
                onMouseEnter={() => setHoveredRowItemId(itemId)}
                onMouseLeave={() => setHoveredRowItemId(null)}
                expandOnRowClick={expandableProps?.expandOnRowClick}
                hasSpacer={hasSpacer}
                isRowExpanded={isRowExpanded}
                $isSelectable={isSelectable}
                {...expandOnClickProps}
            >
                <HBNewTableCellList
                    columnDefinitions={columnDefinitions}
                    item={item}
                    isRowHovered={isRowHovered}
                    itemId={itemId}
                    isRowExpanded={isRowExpanded}
                    setIsRowExpanded={setIsRowExpanded}
                />
            </NewTableStyledTrRow>
            {expandableProps?.renderComponent && (
                <HBNewTableExpandedRow
                    colSpan={columnDefinitions.length}
                    renderComponent={expandableProps.renderComponent}
                    isRowExpanded={isRowExpanded}
                    item={item}
                />
            )}
        </>
    );
};

export default React.memo(HBNewTableRow);
